<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Visualização de Veículo
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <form action>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="brand">
                            <span class="required">*</span> Marca:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehicle.brand"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="model">
                            <span class="required">*</span> Modelo:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehicle.model"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="color">
                            <span class="required">*</span> Cor:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehicle.color"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="form-group">
                          <label for="category">
                            <span class="required">*</span> Categoria:
                          </label>
                          <select
                            v-model="vehicle.category_id"
                            class="form-control"
                            disabled
                          >
                            <option
                              v-for="category in categories"
                              :value="category.id"
                              :key="category.id"
                            >
                              {{ category.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="board">
                            <span class="required">*</span> Placa:
                          </label>
                          <input
                            style="text-transform: uppercase"
                            type="text"
                            class="form-control"
                            v-mask="'AAA#X##'"
                            v-model="vehicle.board"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="vehicle_caster_id">
                            <span class="required">*</span> Rodízio:
                          </label>
                          <input
                            v-for="caster in filteredCasters"
                            class="form-control"
                            :value="caster.day_week"
                            :key="caster.id"
                            disabled
                          />
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="type">
                            <span class="required">*</span> Tipo:
                          </label>
                          <select
                            v-model="vehicle.vehicle_type_id"
                            class="form-control"
                            disabled
                          >
                            <option
                              v-for="type in types"
                              :value="type.id"
                              :key="type.id"
                            >
                              {{ type.description }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="combustible">
                            <span class="required">*</span> Combustível:
                          </label>
                          <select
                            v-model="vehicle.combustible"
                            class="form-control"
                            id="combustible"
                            name="combustible"
                            tabindex="5"
                            disabled
                          >
                            <option value="Etanol">Etanol</option>
                            <option value="Gasolina">Gasolina</option>
                            <option value="Flex">Flex</option>
                            <option value="GNV">GNV</option>
                            <option value="Diesel">Diesel</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="form-group">
                          <label for="renavam_code">Código Renavam:</label>
                          <input
                            type="text"
                            class="form-control"
                            v-mask="'###########'"
                            v-model="vehicle.renavam_code"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-4">
                  <div class="car-img">
                    <img
                      :src="vehicle.photo"
                      class="car"
                      alt="Imagem do Veículo"
                    />
                    <qrcode-vue
                      v-if="vehicle.board"
                      class="code"
                      :value="vehicle.board"
                      level="H"
                    ></qrcode-vue>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group">
                    <label for="chassi">Chassi:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="vehicle.chassi"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="current_km">
                      <span class="required">*</span> KM Atual:
                    </label>
                    <the-mask
                      disabled
                      class="form-control"
                      v-model="vehicle.current_km"
                      :mask="['####', '#.###', '##.###', '###.###']"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="year_of_manufacture">
                      <span class="required">*</span> Ano Fab:
                    </label>
                    <input
                      type="text"
                      v-mask="'####'"
                      class="form-control"
                      v-model="vehicle.year_of_manufacture"
                      disabled
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="model_year">
                      <span class="required">*</span> Ano Mod:
                    </label>
                    <input
                      type="text"
                      v-mask="'####'"
                      class="form-control"
                      v-model="vehicle.model_year"
                      disabled
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="branch_id">
                      <span class="required">*</span> Filial:
                    </label>
                    <select
                      v-model="vehicle.branch_id"
                      class="form-control"
                      disabled
                    >
                      <option
                        v-for="branch in branches"
                        :value="branch.id"
                        :key="branch.id"
                      >
                        {{ branch.description }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description">
                      <span class="required">*</span> Descrição:
                    </label>
                    <textarea
                      disabled
                      class="form-control"
                      v-model="vehicle.description"
                      rows="6"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <h6 class="card-subtitle">Últimas Viagens Realizadas</h6>
            <div class="col-md-12">
              <div class="form-group">
                <base-crud
                  crudName
                  newText
                  :table="table"
                  :columns="columns"
                  :options="options"
                  :endPoint="endPoint"
                  :enableAdd="false"
                  :enableEdit="false"
                  :customFilters="customFilters"
                  :enableDelete="false"
                  :enableView="false"
                ></base-crud>
              </div>
            </div>
            <div class="card-header">
              <div class="card-title">
                Histórico de Bloqueio e Desbloqueio do Veiculo
              </div>
            </div>

            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Usuário</th>
                  <th scope="col" style="width: 30%">
                    Data e Hora da Atualização
                  </th>
                  <th scope="col" style="width: 20%">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="vehicle_history_lock in vehicle_history_locks"
                  :key="vehicle_history_lock.id"
                >
                  <td>
                    {{
                      vehicle_history_lock.user
                        ? vehicle_history_lock.user.name
                        : "AUTOMÁTICO"
                    }}
                  </td>
                  <td>{{ vehicle_history_lock.created_at }}</td>
                  <td>{{ vehicle_history_lock.vehicle_status.description }}</td>
                </tr>
              </tbody>
            </table>
            <div class="block text-right">
              <router-link to="/vehicles" class="btn btn-back">
                <i class="fa fa-arrow-left"></i> Voltar
              </router-link>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";

export default {
  data() {
    return {
      url: "",
      previewImage: null,
      vehicle: {
        description: "",
        board: "",
        branch_id: "",
        brand: "",
        color: "",
        model: "",
        year_of_manufacture: "",
        model_year: "",
        renavam_code: "",
        chassi: "",
        combustible: "",
        current_km: "",
        photo: "",
        vehicle_qr_code_photo: "",
        category_id: "",
        vehicle_type_id: "",
      },
      checklist_item: {
        id: "",
        description: "",
        checked: "",
      },
      checklist_items: [],
      link_checklist_items: [],
      categories: [],
      casters: [],
      branches: [],
      types: [],
      vehicles_history_locks: [],
      reserve: {
        user: {
          name: "",
        },
        branch: {
          description: "",
        },
        vehicle_type_id: {
          description: "",
        },
        reserve_status: {
          title: "",
        },
        vehicles: {
          description: "",
          board: "",
        },
      },

      //Base Crud
      customFilters: [
        {
          name: "retreat_date",
          type: "calendar",
          call: "filtered",
        },
        {
          name: "devolution_date",
          type: "calendar",
          call: "filtered",
        },
        {
          name: "created_at",
          type: "calendar",
          call: "filtered",
        },
      ],
      extra: [{}],
      table: "reservesTable",
      pages: [],
      url: "",
      columns: [
        "user_id",
        "retreat_date",
        "devolution_date",
        "created_at",
        // "actions",
      ],
      tableData: ["id"],
      debounce: 800,
      options: {
        filterByColumn: true,
        filterable: ["user_id"],
        sortable: ["user_id", "retreat_date", "devolution_date", "created_at"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          user_id: "Responsável",
          retreat_date: "Data de Retirada",
          devolution_date: "Data de Devolução",
          created_at: "Reservado em",
          actions: "Ações",
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "reserveVehicles/",
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        user_id: "user[name]",
        retreat_date: "retreat_date",
        devolution_date: "devolution_date",
      };
      let filters =
        "orderByDesc=created_at&?vehicle_id=" + this.$route.params.id;
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

    getVehicle: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicles/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.vehicle = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCategories: function (id) {
      const self = this;
      const api = self.$store.state.api + "categories/";

      self.$http
        .get(api)
        .then((response) => {
          self.categories = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    consulta: function (props, row, index) {
      const self = this;
    },
    getHistory: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "reserveVehiclesHistory/?reserve_id=" +
        id +
        "&with[]=reserve_status";
      self.$http
        .get(api)
        .then((response) => {
          self.history = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getReserve: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "reserveVehicles/" +
        id +
        "?with[]=user&with[]=branch&with[]=vehicle_type_id&with[]=reserve_status&with[]=vehicles&with[]=checkout&with[]=checkin";

      self.$http
        .get(api)
        .then((response) => {
          self.reserve = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getCasters: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicleCasters/";

      self.$http
        .get(api)
        .then((response) => {
          self.casters = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVehicleHistoryLocks: function () {
      const self = this;
      let id = self.$route.params.id;
      const api =
        self.$store.state.api +
        "vehicle_history_locks/?paginated=false&vehicle_id=" +
        id +
        "&with[]=user&with[]=vehicle_status";

      self.$http
        .get(api)
        .then((response) => {
          self.vehicle_history_locks = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTypes: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicleTypes/";

      self.$http
        .get(api)
        .then((response) => {
          self.types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getChecklistItems: function () {
      const self = this;
      const api = self.$store.state.api + "checklistItems/";

      self.$http
        .get(api)
        .then((response) => {
          self.checklist_items = response.data.data;
          self.ciCount = response.data.count;

          for (let i = 0; i < self.ciCount; i++) {
            if (
              self.checklist_items[i].id == 1 ||
              self.checklist_items[i].id == 3
            ) {
              self.checked[i] = true;
            } else {
              self.checked[i] = false;
            }
          }
        })
        .catch((error) => {});
    },
  },
  computed: {
    filteredCasters: function () {
      if (this.vehicle.board.length >= 7) {
        var end_plate = this.vehicle.board.charAt(
          this.vehicle.board.length - 1
        );
        return this.casters.filter((x) => x.end_plate == end_plate);
      }
    },
  },
  mounted: function () {
    const self = this;
    self.getCategories();
    self.getCasters();
    self.getBranches();
    self.getTypes();
    self.getChecklistItems();
    self.getReserve();
    self.getHistory();
    self.getVehicleHistoryLocks();
    let id = self.$route.params.id;
    if (id) {
      self.getVehicle(id);
    }

    $("html, body").scrollTop(0);
  },
  components: {
    BaseCrud,
    QrcodeVue,
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Vehicle/View.vue